import React from 'react';

const whyChooseCards = [
  {
    step: '01',
    title: 'Idea & Market Analysis',
    desc: 'We begin every step with complete research and strategic planning to understand your business objectives and target audience. We conduct detailed market analysis and audience persona development to create a perfect strategy. We also recognize your unique selling points to stay ahead of the competition.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <circle cx="11.5" cy="14.5" r="2.5" />
        <path d="m13.5 16.5 2 2" />
      </svg>
    )
  },
  {
    step: '02',
    title: 'Campaign Design and Implementation',
    desc: 'Being one of the best digital marketing companies in Karachi, we implement the best marketing campaigns across multiple digital channels. We create content strategies and targeted advertising campaigns to target your potential customers. Our team optimizes your website for search engines and a strong social media presence. We use advanced tracking systems and conversion optimization techniques to generate more revenue.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="m18 2 4 4-12 12H6v-4L18 2z" />
        <path d="m15 5 4 4" />
        <path d="m6 18-3 3" />
        <path d="M21 21H3" />
      </svg>
    )
  },
  {
    step: '03',
    title: 'Monitoring',
    desc: 'Experts Communication performs continuous monitoring and analysis from the start so that your campaigns deliver optimal results. We track key performance indicators and analyze user behavior patterns to see what works best for your brand. Our experts monitor conversion rates and assess campaign productivity across all channels.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
        <path d="m9 13 2 2 4-4" />
      </svg>
    )
  },
  {
    step: '04',
    title: 'Efficient Rollout',
    desc: 'Our digital marketing company in Pakistan uses performance data and market insights to refine and optimize your campaigns. We perform A/B testing of different elements and adjust the targeting parameters on the basis of results. Our digital marketers reallocate the budget to the highest-performing channels and implement new strategies if we see any emerging opportunities for your brand. When the campaigns become successful, we smartly expand what works best while maintaining cost efficiency.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>
    )
  }
];

function WhyChooseDigitalMarketing() {
  const scrollToForm = () => {
    const formEl = document.getElementById('digital-marketing-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="why-choose-dig-section">
      <div className="container">
        {/* Centered Header */}
        <div className="why-choose-dig-header">
          <h2 className="why-choose-dig-title">
            Why Choose Our <span className="text-red">Leading Digital Marketing Agency?</span>
          </h2>

          <p className="why-choose-dig-subtitle">
            Experts Communication believes in client satisfaction and quality services. As a leading BPO & IT company, we help many businesses in multiple industries to increase their revenue. We want to create a long-term and fruitful relationship with our clients to sustain their online growth, because we only believe in presenting results and growth.
          </p>
        </div>

        {/* 2x2 Cards Grid */}
        <div className="why-choose-dig-grid">
          {whyChooseCards.map((card) => (
            <div key={card.step} className="why-choose-dig-card" onClick={scrollToForm}>
              {/* Top Row: Step Number & Icon */}
              <div className="why-choose-dig-card-top">
                <span className="why-choose-dig-step">{card.step}</span>
                <div className="why-choose-dig-icon-box">
                  {card.icon}
                </div>
              </div>

              {/* Title */}
              <h3 className="why-choose-dig-card-title">{card.title}</h3>

              {/* Description */}
              <p className="why-choose-dig-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseDigitalMarketing;
